<div class="row text-center">
  <div class="col-12">
    <h2>
      {{text}}
<!--      Naozaj si želáte vymazať toto VTC?-->
    </h2>
  </div>
</div>
<div class="row justify-content-between">
  <button color="primary" mat-button [mat-dialog-close]="false">Nie</button>
  <button color="warn" mat-button [mat-dialog-close]="true">Áno</button>
</div>
